export default "__VITE_ASSET__652a106d__"